(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casafab-matelas-test"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    const reviewTrack = root.querySelector('.cfm-review-wall .cfm-testimonial-grid');
    if (reviewTrack && !reviewTrack.dataset.controlsBound) {
      reviewTrack.dataset.controlsBound = 'true';
      const buttons = root.querySelectorAll('[data-reviews-step]');
      const refresh = () => {
        buttons.forEach(button => {button.disabled = Number(button.dataset.reviewsStep) < 0 ? reviewTrack.scrollLeft < 2 : reviewTrack.scrollLeft + reviewTrack.clientWidth >= reviewTrack.scrollWidth - 2;});
        const card = reviewTrack.querySelector('article');
        const position = root.querySelector('.cfm-review-position');
        if (card && position) {
          const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(reviewTrack).gap) || 0);
          const first = Math.round(reviewTrack.scrollLeft / step) + 1;
          const visible = Math.max(1, Math.floor((reviewTrack.clientWidth + 2) / card.getBoundingClientRect().width));
          const total = reviewTrack.children.length;
          position.textContent = (visible > 1 ? first + '–' + Math.min(total, first + visible - 1) : first) + ' / ' + total;
        }
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = reviewTrack.querySelector('article');
        const gap = parseFloat(getComputedStyle(reviewTrack).gap) || 0;
        reviewTrack.scrollBy({left: Number(button.dataset.reviewsStep) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }));
      reviewTrack.addEventListener('scroll', refresh, {passive:true});
      new ResizeObserver(refresh).observe(reviewTrack);
      refresh();
    }
    const deliveryLink = root.querySelector('.cfm-delivery a');
    if (deliveryLink && !deliveryLink.dataset.bound) {
      deliveryLink.dataset.bound = 'true';
      deliveryLink.addEventListener('click', () => {
        const info = root.querySelector(deliveryLink.getAttribute('href'));
        if (info && info.tagName === 'DETAILS') info.open = true;
      });
    }
    root.querySelectorAll('.cfm-clip').forEach(clip => {
      if (clip.dataset.bound) return;
      clip.dataset.bound = 'true';
      const toggle = clip.parentElement.querySelector('.cfm-clip-toggle');
      if (toggle) {
        const syncToggle = () => { toggle.setAttribute('aria-label', clip.paused ? toggle.dataset.play : toggle.dataset.pause); toggle.firstElementChild.textContent = clip.paused ? '▶' : 'Ⅱ'; };
        toggle.addEventListener('click', () => { if (clip.paused) clip.play().catch(() => {}); else clip.pause(); });
        clip.addEventListener('play', syncToggle);
        clip.addEventListener('pause', syncToggle);
        syncToggle();
      }
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false, userPaused = false, automaticPause = false;
      const stop = () => { if (!clip.paused) { automaticPause = true; clip.pause(); } };
      const resume = () => { if (visible && !document.hidden && !motion.matches && !userPaused) clip.play().catch(() => {}); };
      clip.addEventListener('pause', () => { if (automaticPause) automaticPause = false; else userPaused = true; });
      clip.addEventListener('play', () => { userPaused = false; });
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) resume(); else stop();
      }, { threshold: 0.25 });
      observer.observe(clip);
      motion.addEventListener('change', () => { if (motion.matches) stop(); else resume(); });
      document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else resume(); });
    });
    const video = root.querySelector('.cfm-film');
    const button = root.querySelector('[data-film-toggle]');
    if (!video || !button || video.dataset.ready) return;
    video.dataset.ready = 'true';
    const sync = () => { button.textContent = video.paused ? button.dataset.play : button.dataset.pause; };
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    button.addEventListener('click', () => { if (video.paused) video.play().catch(sync); else video.pause(); });
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    reduceMotion.addEventListener('change', event => { if (event.matches) video.pause(); });
    if (!reduceMotion.matches) video.play().catch(sync);
    sync();
  }
  document.querySelectorAll('.cfm').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.cfm').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-promo-badge"] && !Shopify.designMode) return;
  try {
    
  class FloatingPromoBadge {
    constructor(element) {
      this.element = element;
      this.sectionId = element.dataset.sectionId;
      this.dismissMode = element.dataset.dismissMode;
      this.delay = Number(element.dataset.delay || 0);
      this.attentionDuration = Number(element.dataset.attentionDuration || 0);
      this.closeButton = element.querySelector('[data-floating-promo-close]');
      this.storageKey = `floating-promo-badge-${this.sectionId}`;

      if (this.isDismissed()) {
        this.element.classList.add('is-hidden');
        return;
      }

      window.setTimeout(() => {
        this.element.classList.add('is-visible');
        this.playAttention();
      }, this.delay);

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.dismiss());
      }
    }

    playAttention() {
      if (this.attentionDuration <= 0 || this.element.classList.contains('floating-promo-badge--attention-none')) {
        return;
      }

      window.setTimeout(() => {
        this.element.classList.add('is-attention');
      }, 520);

      window.setTimeout(() => {
        this.element.classList.remove('is-attention');
      }, this.attentionDuration + 520);
    }

    isDismissed() {
      if (this.dismissMode === 'never') {
        return false;
      }

      if (this.dismissMode === 'session') {
        return window.sessionStorage.getItem(this.storageKey) === 'dismissed';
      }

      const value = window.localStorage.getItem(this.storageKey);

      if (!value) {
        return false;
      }

      const expiresAt = Number(value);
      return expiresAt > Date.now();
    }

    dismiss() {
      if (this.dismissMode === 'session') {
        window.sessionStorage.setItem(this.storageKey, 'dismissed');
      }

      if (this.dismissMode === 'one_day') {
        window.localStorage.setItem(this.storageKey, String(Date.now() + 86400000));
      }

      if (this.dismissMode === 'seven_days') {
        window.localStorage.setItem(this.storageKey, String(Date.now() + 604800000));
      }

      this.element.classList.remove('is-visible');
      window.setTimeout(() => {
        this.element.classList.add('is-hidden');
      }, 260);
    }
  }

  const initFloatingPromoBadges = () => {
    document.querySelectorAll('[data-floating-promo-badge]').forEach((element) => {
      if (!element.dataset.initialized) {
        element.dataset.initialized = 'true';
        new FloatingPromoBadge(element);
      }
    });
  };

  initFloatingPromoBadges();

  document.addEventListener('shopify:section:load', initFloatingPromoBadges);

  } catch(e) { console.error(e); }
})();
})();
